import React, { Component } from 'react';
import reqwest from 'reqwest';
import swal from '@sweetalert/with-react';

import settings from '../../../../../../settings';

import DataContainer from '../../../../../logic/dataContainer';

import Loader from '../../../../../components/Loader';
import Form from '../../../../../components/Form';
import ContentBox from '../../../../../components/FormArea/ContentBox';
import Dropdown from '../../../../../components/Inputs/Dropdown';
import RightSide from '../../../../../components/FormArea/RightSide';
import Button from '../../../../../components/Button';
import { faSave, faTrash } from '@fortawesome/pro-solid-svg-icons';
import Input from '../../../../../components/Inputs/Input';
import getConstants from '../../../../../logic/constants';
import checkAvailable from '../../../../../logic/checkAvailable';

class BasedataDetail extends Component {
  constructor(props) {
    super(props);

    this.parentRoute = this.props.match.url.replace(new RegExp(`/${props.match.params.userId}$`), '');

    this.state = {
      loading: true,
      positions: [],
      Workdata: {},
      Privatedata: {},
      Additionalinfos: {},
      RightSide: {},
      Baseoffice: {},
    };

    const dataPromise = reqwest({
      method: 'get',
      url: settings.usermanagement.general.get,
      data: {
        Token: localStorage.getItem('token'),
        Usernr: this.props.UserGuid,
      },
    }).then(res => {
      this.dataContainer = new DataContainer(res);
    });

    const positionPromise = getConstants('Positiontype').then(positions => {
      this.setState({
        positions,
      });
    });

    const maritalStatusPromise = getConstants('MaritalStatus').then(maritalStatus => {
      this.setState({
        maritalStatus,
      });
    });

    const rlPromise = reqwest({
      method: 'get',
      url: settings.usermanagement.general.getUserForPosition,
      data: {
        Token: localStorage.getItem('token'),
        Position: 'RL',
      },
    }).then(users => {
      users = JSON.parse(users);

      this.setState({
        users: users.map(element => {
          return {
            value: element.Params.Guid,
            label: `${element.Params.Firstname} ${element.Params.Lastname} (${element.Params.Expnr})`,
          };
        }),
      });
    });

    Promise.all([dataPromise, positionPromise, maritalStatusPromise, rlPromise]).then(() => {
      this.setState({
        loading: false,
      });
    });
  }

  delete = () => {
    swal({
      title: 'Sind Sie sich sicher?',
      content: (
        <p>
          Möchten Sie{' '}
          <span className='Indented'>
            {this.dataContainer.get('Workdata', 'Lastname')}, {this.dataContainer.get('Workdata', 'Firstname')}
          </span>{' '}
          wirklich löschen?
          <br />
          Der Nutzer wird damit endgültig gelöscht.
        </p>
      ),
      icon: 'warning',
      buttons: ['Abbrechen', 'Löschen'],
      dangerMode: true,
    }).then(willDelete => {
      if (willDelete) {
        reqwest({
          method: 'POST',
          url: settings.usermanagement.general.delete,
          data: {
            Guid: this.props.UserGuid,
          },
        })
          .then(res => {
            res = JSON.parse(res);

            if (res.DeleteResult === 'Deleted') {
              swal({
                title: 'Erfolgreich!',
                content: (
                  <p>
                    <span className='Indented'>
                      {this.dataContainer.get('Workdata', 'Lastname')}, {this.dataContainer.get('Workdata', 'Firstname')}
                    </span>{' '}
                    wurde erfolgreich gelöscht.
                  </p>
                ),
                icon: 'success',
              });
              this.props.history.replace(this.parentRoute);
            }
          })
          .catch(() => {
            throw new Error('Something went very very wrong...');
          });
      }
    });
  };

  save = async () => {
    const isValid = await this.form.validate();
    if (!isValid) {
      swal({
        title: 'Überprüfung fehlgeschlagen!',
        icon: 'error',
        text: 'Bitte überprüfen Sie Ihre Eingaben.',
      });
      return;
    }

    const data = this.dataContainer.getStringified();

    reqwest({
      method: 'POST',
      url: settings.usermanagement.general.save,
      data: {
        Token: localStorage.getItem('token'),
        User: data,
      },
    }).then(() => {
      document.querySelector('.FormArea-Title').innerHTML = `#${this.dataContainer.get('Workdata', 'Expnr')} ${this.dataContainer.get(
        'Workdata',
        'Firstname',
      )} ${this.dataContainer.get('Workdata', 'Lastname')}`;
      swal({
        title: 'Erfolgreich!',
        text: 'Der Nutzer wurde erfolgreich gespeichert.',
        icon: 'success',
      });
    });
  };

  render() {
    if (this.state.loading) {
      return <Loader />;
    }

    return (
      <>
        <div className='FormArea-Form-Left'>
          <Form ref={node => (this.form = node)}>
            <ContentBox title='Login'>
              <Input type='text' label='Nutzername:' defaultValue={this.dataContainer.get('Login', 'Username')} name='Nutzername' isDisabled />{' '}
              <Input type='password' label='Passwort:' defaultValue='*******' name='Passwort' isDisabled />
            </ContentBox>
            <ContentBox title='Stammdaten'>
              <Input
                type='text'
                label='Vorname:'
                validator={[
                  {
                    required: true,
                    error: 'Bitte füllen Sie dieses Feld aus',
                  },
                ]}
                onChange={value => {
                  this.dataContainer.set('Workdata', 'Firstname')(value);
                }}
                defaultValue={this.dataContainer.get('Workdata', 'Firstname')}
                name='Vorname'
              />
              <Input
                type='text'
                label='Nachname:'
                validator={[
                  {
                    required: true,
                    error: 'Bitte füllen Sie dieses Feld aus',
                  },
                ]}
                onChange={value => {
                  this.dataContainer.set('Workdata', 'Lastname')(value);
                }}
                defaultValue={this.dataContainer.get('Workdata', 'Lastname')}
                name='Nachname'
              />
              <Input
                type='text'
                label='E-Mail:'
                validator={[
                  {
                    required: true,
                    error: 'Bitte füllen Sie dieses Feld aus',
                  },
                  {
                    type: 'email',
                    error: 'Bitte geben Sie eine valide E-Mail Adresse ein',
                  },
                  {
                    custom: async value => {
                      if (this.dataContainer.getInitial('Workdata', 'EMail') !== value) {
                        return await checkAvailable('email', value);
                      }
                      return true;
                    },
                    error: 'Diese E-Mail Adresse wird bereits verwendet',
                  },
                ]}
                onChange={value => {
                  this.dataContainer.set('Workdata', 'EMail')(value);
                }}
                defaultValue={this.dataContainer.get('Workdata', 'EMail')}
                name='E-Mail'
              />
            </ContentBox>
            <ContentBox title='Berechtigung'>
              <Dropdown
                label='Position: (Rolle/Gruppe)'
                isSearchable
                getSelected={value => {
                  this.dataContainer.set('Workdata', 'Position')(value);
                }}
                defaultValue={this.dataContainer.get('Workdata', 'Position')}
                options={this.state.positions}
                validator={[
                  {
                    required: true,
                    error: 'Bitte füllen Sie dieses Feld aus',
                  },
                ]}
                name='Position'
              />
            </ContentBox>
          </Form>
        </div>
        <RightSide
          createDate={this.dataContainer.get('RightSide', 'CreateDate')}
          createUserName={this.dataContainer.get('RightSide', 'CreateUserName')}
          updateDate={this.dataContainer.get('RightSide', 'UpdateDate')}
          updateUserName={this.dataContainer.get('RightSide', 'UpdateUserName')}
        >
          <Button big type='danger' icon={faTrash} onClick={this.delete}>
            Löschen
          </Button>
          <Button big type='primary' icon={faSave} onClick={this.save}>
            Speichern
          </Button>
        </RightSide>
      </>
    );
  }
}

export default BasedataDetail;
